import { render } from "./index.vue?vue&type=template&id=183005af&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=183005af&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183005af"],['__file',"src/views/chess/section/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "183005af"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('183005af', __exports__)) {
    console.log('reload')
    api.reload('183005af', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=183005af&scoped=true", () => {
    console.log('re-render')
    api.rerender('183005af', render)
  })

}


export default __exports__